import { useEffect, useMemo, useState } from 'react';

import { useLocation, useParams } from 'react-router-dom';

import useTheme from 'api/useTheme';
import { extractColorValue } from 'utils/colorUtils';

import { defaultGeneralTheme } from '../GeneralSettings/defaults';

import { defaultCheckoutTheme, getDefaultFontColorByVersion } from './defaults';
import useFeatureFlags from 'api/useFeatureFlags';
import { EFeatureFlag } from 'constants/enums';

export const useGetCheckoutInitialValues = () => {
  const location = useLocation();

  const { publisherId } = useParams();
  const { featureFlags } = useFeatureFlags({ publisherId });

  const isCheckoutV3Enabled = useMemo(
    () => featureFlags?.[EFeatureFlag.CHECKOUT_V3],
    [featureFlags]
  );

  const [initialValues, setInitialValue] = useState<any>(defaultCheckoutTheme);

  const safeInitialValues = initialValues || defaultCheckoutTheme;

  const { getGeneralTheme: generalTheme, getCheckoutTheme: checkoutTheme } =
    useTheme(publisherId);

  useEffect(() => {
    setInitialValue({
      backgroundImage: checkoutTheme.data?.backgroundImage || '',
      buttonColor: extractColorValue(checkoutTheme.data?.buttonColor) || '',
      buttonTextColor:
        extractColorValue(checkoutTheme.data?.buttonTextColor) || '',
      mobileBgImage: checkoutTheme.data?.mobileBgImage || '',
      primaryColor: extractColorValue(checkoutTheme.data?.primaryColor) || '',
      textColor: getDefaultFontColorByVersion(
        isCheckoutV3Enabled,
        checkoutTheme.data?.textColor
      ),
      footerConfiguration:
        checkoutTheme.data?.footerConfiguration ||
        defaultCheckoutTheme.footerConfiguration,
      logo:
        checkoutTheme.data?.logo ||
        generalTheme?.data?.logo ||
        defaultGeneralTheme.logo,
      publisherId: checkoutTheme.data?.publisherId || '',
      _id: checkoutTheme.data?._id || ''
    });
  }, [checkoutTheme.data, generalTheme.data, location, isCheckoutV3Enabled]);

  return { initialValues: safeInitialValues };
};
